import { FC } from "react";
import { Question } from "@types";
import { ReviewInfo } from "@components/ReviewInfo/ReviewInfo";
import { ReviewTextBlock } from "@components/ReviewTextBlock/ReviewTextBlock";
import { Avatar } from "@components/Avatar/Avatar";
import styles from "./QuestionBlock.module.css";
import { useBreakpoint } from "@hooks/useBreakpoint";

interface QuestionBlockProps {
  question: Question;
}

export const QuestionBlock: FC<QuestionBlockProps> = ({ question }) => {
  const breakpoint = useBreakpoint();

  const getAvatarSize = () => {
    return breakpoint === "mobile" ? "small" : "medium";
  };

  return (
    <div className={styles.reviewBlock}>
      <div className={styles.mainContent}>
        <div className={styles.reviewInfoRow}>
          <Avatar alt={`${question.author}'s avatar`} size={getAvatarSize()} />
          <ReviewInfo 
            userName={question.author} 
            date={question.date} 
            store={question.store} 
            productLink={question.productLink} 
          />
        </div>

        <ReviewTextBlock comment={question.comment} answer={question.answer} />
      </div>
    </div>
  );
};
